import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";

const DesktopFoodTruck = dynamic(() => import('../../components/restaurants/fineDine/DesktopFineDine'), {
  loading: () => <Loading />,

});
const MobileFoodTruck = dynamic(() => import('../../components/restaurants/fineDine/MobileFineDine'), {
  loading: () => <Loading />,

});

const fineDine = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>Best Fine Dine POS Billing Software & Solution for Restaurants</title>
        <link rel="canonical" href="https://queuebuster.co/restaurants/fine-dine-pos-billing-software" />
        <link rel="alternate" href="https://queuebuster.co/restaurants/fine-dine-pos-billing-software" hrefLang="en-us" />
        <meta name="description" content="Explore the ultimate fine dine POS billing software and solution for your restaurant. Enhance your operations with our top-rated fine dine billing software solutions." />
        <meta property="og:title" content="Best Fine Dine POS Billing Software & Solution for Restaurants" />
        <meta property="og:description" content="Explore the ultimate fine dine POS billing software and solution for your restaurant. Enhance your operations with our top-rated fine dine billing software solutions." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/assets/outlet-og-img/fine-dine.jpg" />
        <meta property="og:url" content="https://queuebuster.co/restaurants/fine-dine-pos-billing-software" />
      </Head>
         <SchemaTags page="fine-dine-pos-billing-software" />
      {
        mobileView ? <MobileFoodTruck /> : <DesktopFoodTruck />
      }
    </>
  )
}

export default fineDine